import instance from "../http";
import { getHeader } from "../../utils/utils";
import { projectManagement, projectPersmission } from "../../constants/path";

export async function getProjectPermissionApi(projectId) {
    const headers = getHeader();
    const response = await instance.get(projectPersmission.GET_PROJECT_PERMISSION + projectId, headers);
    return response;
}

export async function generateJWTApi(data) {
    const headers = getHeader();
    const response = await instance.post(projectPersmission.GENERATE_JWT, data, headers)
    return response;
}